import { NAMESPACE_ENUM } from '@/components/shared/file-list/file-list.service';
import { DacResponse } from '@/types';

export const getDACPVItems = (dac: DacResponse) => {
  return {
    'Procès verbal CPMP': { singular: 'PV CPMP', items: dac.pvCPMP || [], nameSpace: NAMESPACE_ENUM.PV },
    'Extraits Procès verbal CPMP': {
      items: dac.extraitCPMP || [],
      nameSpace: NAMESPACE_ENUM.SNIPPET,
    },
    'Documents examinés/Justifs CPMP': {
      items: dac.documentCPMP || [],
      nameSpace: NAMESPACE_ENUM.MEETING_DAC,
    },
    'Procès verbal CNCMP (Permanente)': {
      items: dac.pvCNCMPPermanente || [],
      nameSpace: NAMESPACE_ENUM.PV,
    },
    'Extraits Procès verbal CNCMP (Permanente)': {
      items: dac.extraitCNCMPP || [],
      nameSpace: NAMESPACE_ENUM.SNIPPET,
    },
    'Documents examinés/Justifs CNCMP (Permanente)': {
      items: dac.documentCNCMPPermanente || [],
      nameSpace: NAMESPACE_ENUM.MEETING_DAC,
    },
    'Procès verbal CNCMP (Spécialisée)': {
      items: dac.pvCNCMPSpecialise || [],
      nameSpace: NAMESPACE_ENUM.PV,
    },
    'Documents examinés/Justifs CNCMP (Spécialisée)': {
      items: dac.documentCNCMPSpecialise || [],
      nameSpace: NAMESPACE_ENUM.MEETING_DAC,
    },
  };
};
